import React, {Fragment, useContext} from "react";
import {getDataFormattata} from "../utility/common";
import {RuoliContext} from "../context/RuoliContext";
import {aggiornaUtenteApi, getUtenteByIdApi} from "../services/UtentiServices";
import {LoaderContext} from "../context/LoaderContext";

export const useSociUtils = ({
                                 reloadFunction,
                                 annullaIscrizionePermessa = false,
                             }) => {

    const {
        isRuoloAdmin,
        isRuoloSegreteria,
    } = useContext(RuoliContext);
    const {startChiamata, endChiamata} = useContext(LoaderContext);

    const annullaIscrizione = async (el) => {
        startChiamata();
        const response = await getUtenteByIdApi(el.id_utente);
        endChiamata();
        let utente = response.data.data;
        if (utente) {
            utente.newsletter = 0;
            utente.id_tipo_socio = 'NONASSOC';

            startChiamata();
            await aggiornaUtenteApi(el.id_utente, utente);
            endChiamata();
            if (reloadFunction) {
                reloadFunction();
            }
        }
    }

    const getRigaInfoSocio = (el, showInfoRegistrazione, showAltreInfo) => {
        return (
            <Fragment>
                <div className={"row"}>
                    <div className={"col-md-4 col-sm-6"}>
                        Cognome: <strong>{el.cognome || '-'}</strong>
                    </div>
                    <div className={"col-md-4 col-sm-6"}>
                        Nome: <strong>{el.nome || '-'}</strong>
                    </div>
                    <div className={"col-md-4 col-sm-6"}>
                        Tipo socio: <strong>{el.tipo_socio || '-'}</strong>
                    </div>

                    <div className={"col-md-4 col-sm-6"}>
                        N° tessera RFI: <strong>{el.numero_tessera_rfi || '-'}</strong>
                    </div>
                    <div className={"col-md-4 col-sm-6"}>
                        N° tessera Abarth: <strong>{el.numero_tessera_abarth || '-'}</strong>
                    </div>
                    <div className={"col-md-4 col-sm-6"}>
                        Numero tessera ASI: <strong>{el.numero_tessera_asi || '-'}</strong>
                    </div>
                    <div className={"col-md-4 col-sm-6"}>
                        Scadenza: <strong>{el.scadenza || '-'}</strong>
                    </div>

                    <div className={"col-md-4 col-sm-6"}>
                        Data di nascita: <strong>{getDataFormattata(el.data_nascita)}</strong>
                    </div>
                    <div className={"col-md-4 col-sm-6"}>
                        Luogo di nascita: <strong>{el.luogo_nascita || '-'}</strong>
                    </div>
                    <div className={"col-md-4 col-sm-6"}>
                        Anno iscrizione: <strong>{el.anno_iscrizione || '-'}</strong>
                    </div>

                    <div className={"col-md-4 col-sm-6"}>
                        Codice fiscale: <strong>{el.codice_fiscale || '-'}</strong>
                    </div>
                    <div className={"col-md-4 col-sm-6"}>
                        E-mail: <strong>{el.email || '-'}</strong>
                    </div>
                    <div className={"col-md-4 col-sm-6"}>
                        Club: <strong>{el.club || '-'}</strong>
                    </div>
                    <div className={"col-md-4 col-sm-6"}>
                        Agenzia: <strong>{el.agenzia || '-'}</strong>
                    </div>
                    <div className={"col-md-4 col-sm-6"}>
                        Agenzia originaria: <strong>{el.agenzia_creazione || '-'}</strong>
                    </div>
                    <div className={"col-md-4 col-sm-6"}>
                        Azienda: <strong>{el.azienda || '-'}</strong>
                    </div>

                    <div className={"col-md-12"}>
                        <hr/>
                        <h6>Residenza</h6>
                    </div>

                    <div className={"col-md-4 col-sm-6"}>
                        Nazione: <strong>{el.nazione || '-'}</strong>
                    </div>
                    <div className={"col-md-4 col-sm-6"}>
                        Regione: <strong>{el.regione || '-'}</strong>
                    </div>
                    <div className={"col-md-4 col-sm-6"}>
                        Provincia: <strong>{el.provincia || '-'}</strong>
                    </div>

                    <div className={"col-md-4 col-sm-6"}>
                        Localià: <strong>{el.localita || '-'}</strong>
                    </div>
                    <div className={"col-md-4 col-sm-6"}>
                        CAP: <strong>{el.cap || '-'}</strong>
                    </div>
                    <div className={"col-md-4 col-sm-6"}>
                        Indirizzo: <strong>{el.indirizzo || '-'}</strong> N° <strong>{el.numero_civico || '-'}</strong>
                    </div>

                    <div className={"col-md-12"}>
                        <hr/>
                        <h6>Indirizzo di spedizione</h6>
                    </div>

                    <div className={"col-md-4 col-sm-6"}>
                        Nazione: <strong>{el.nazione_sped || '-'}</strong>
                    </div>
                    <div className={"col-md-4 col-sm-6"}>
                        Regione: <strong>{el.regione_sped || '-'}</strong>
                    </div>
                    <div className={"col-md-4 col-sm-6"}>
                        Provincia: <strong>{el.provincia_sped || '-'}</strong>
                    </div>

                    <div className={"col-md-4 col-sm-6"}>
                        Localià: <strong>{el.localita_sped || '-'}</strong>
                    </div>
                    <div className={"col-md-4 col-sm-6"}>
                        CAP: <strong>{el.cap_sped || '-'}</strong>
                    </div>
                    <div className={"col-md-4 col-sm-6"}>
                        Indirizzo: <strong>{el.indirizzo_sped || '-'}</strong>
                    </div>
                    <div className={"col-md-4 col-sm-6"}>
                        N° civico: <strong>{el.numero_civico_sped || '-'}</strong>
                    </div>
                    <div className={"col-md-4 col-sm-6"}>
                        Nominativo: <strong>{el.nominativo_sped || '-'}</strong>
                    </div>

                    <div className={"col-md-12"}>
                        <hr/>
                        <h6>Contatti</h6>
                    </div>

                    <div className={"col-md-4 col-sm-6"}>
                        Telefono casa: <strong>{el.tel_casa || '-'}</strong>
                    </div>
                    <div className={"col-md-4 col-sm-6"}>
                        Telefono lavoro: <strong>{el.tel_lavoro || '-'}</strong>
                    </div>
                    <div className={"col-md-4 col-sm-6"}>
                        Fax: <strong>{el.fax || '-'}</strong>
                    </div>

                    {
                        showAltreInfo && showAltreInfo === true &&
                        <Fragment>
                            <div className={"col-md-12"}>
                                <hr/>
                            </div>

                            <div className={"col-md-4 col-sm-6"}>
                                Newsletter: <strong>{el.newsletter == '1' ? 'Sì' : 'No'}</strong>
                            </div>
                            <div className={"col-md-4 col-sm-6"}>
                                Da ratificare: <strong>{el.da_ratificare == '1' ? 'Sì' : 'No'}</strong>
                            </div>
                            <div className={"col-md-4 col-sm-6"}>
                                Delegazione: <strong>{el.delegazione || '-'}</strong>
                            </div>
                            <div className={"col-md-4 col-sm-6"}>
                                Numero veicoli: <strong>{el.num_veicoli || '-'}</strong>
                            </div>
                            <div className={"col-md-4 col-sm-6"}>
                                Tipo Club: <strong>{el.club || '-'}</strong>
                            </div>
                            <div className={"col-md-4 col-sm-6"}>
                                Id utente: <strong>{el.id_utente || '-'}</strong>
                            </div>

                            <div className={"col-md-8"}>
                                Note persona: <strong>{el.note || '-'}</strong>
                            </div>
                            <div className={"col-md-4 col-sm-6"}>
                                Comunicazioni via E-Mail: <strong>{el.comunicazioni_email == '1' ? 'Sì' : 'No'}</strong>
                            </div>
                        </Fragment>
                    }
                </div>
                {
                    showInfoRegistrazione && showInfoRegistrazione === true ?
                        <div className={"row mt-2"}>
                            <div className={"col-md-8"}>
                                Motivi registrazione:
                                {
                                    el.motiviRegistrazione && el.motiviRegistrazione.length > 0 ?
                                        <ul>
                                            {
                                                el.motiviRegistrazione.map((motivo) => <li
                                                        key={motivo.id_motivo_registrazione}>
                                                        <strong>
                                                            {
                                                                motivo.descrizione + (motivo.note !== '' ? ' - ' + motivo.note : '')
                                                            }
                                                        </strong>
                                                    </li>
                                                )
                                            }
                                        </ul>
                                        : '-'
                                }
                            </div>
                            <div className={"col-md-4 col-sm-6"}>
                                Informazioni sulle auto da iscrivere: <strong>{el.info_auto || '-'}</strong>
                            </div>
                        </div>
                        : ''
                }
                {
                    (isRuoloAdmin() || isRuoloSegreteria()) && annullaIscrizionePermessa &&
                    <div className={"row mt-4"}>
                        <div className={"col-md-12 text-center"}>
                            <button
                                type={'button'}
                                className={'btn btn-dark'}
                                data-toggle="tooltip" title="Annulla iscrizione"
                                onClick={() => {
                                    annullaIscrizione(el);
                                }}
                            >
                                <i className="fas fa-times"/> Annulla iscrizione
                            </button>
                        </div>
                    </div>
                }
            </Fragment>
        )
    }

    return {
        getRigaInfoSocio,
    };
};